import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-terminos',
  templateUrl: './terminos.component.html',
  styleUrls: ['./terminos.component.scss'],
})
export class TerminosComponent implements OnInit {

  constructor(public poper: PopoverController) { }

  ngOnInit() {}

  async cerraPopOver(){
    
    this.poper.dismiss({
      
    });
  
  }
}
